export class RequestData{
    id: string;
}